"use strict";

define('model/user',['./base'], function (BaseModel) {
  var User = BaseModel.extend({}, {
    IRB_USER: 'ROLE_IRB_USER',
    IRB_ANALYST: 'ROLE_IRB_ANALYST',
    IRB_REVIEWER: 'ROLE_IRB_BOARD_MEMBER',
    IRB_ORG_APPROVER: 'ROLE_IRB_ORG_APPROVER',
    IRB_ADMIN: 'ROLE_IRB_ADMIN'
  });
  BaseModel.register('User', User);
  return User;
});

